<div class="fullwidth" fxLayout="column">
    <p *ngIf="FileWindowDeadline && FileWindowDeadline.DateEnd"><strong>Deadline for submission: </strong><span>{{FileWindowDeadline.DateEnd | date:'EEEE, MMM. d, yyyy'}}</span></p>
    <div *ngIf="FileWindowOpen !== true"><strong>Note: </strong>The window for uploading the {{AttachmentType?.Description}} has closed. No files may be uploaded at this time.</div>
    <div *ngIf="FileWindowOpen === true && Instructions" [innerHTML]="Instructions | safeHTML" class="halfWidth"></div>
    <div *ngIf="FileWindowOpen === true && !Instructions" fxLayout="row" fxLayoutAlign="space-between start" class="margin-bottom">
        <p>Use the button provided below to upload a {{AttachmentType?.Description}} file for the nominee.<span *ngIf="HasFileSizeLimit"> Submissions must be no more than {{AttachmentType?.SizeLimit | fileSize:0}} in size.</span></p>
    </div>

    <mat-card *ngIf="hasBlankDocument">
        <h3>Download</h3>
        <p>Click this button to download the document. Please print it, fill it out, then scan it and upload it back to this page.</p>
        <button mat-raised-button [color]="'primary'" type="button" (click)="downloadOriginal()">Download Blank Document</button>
    </mat-card>

    <mat-card>
        <h2 class="mat-headline primarycolor500">Upload</h2>
        <p>Please choose your file here</p>
        <div>
            <mat-form-field><input matInput type="text" readonly placeholder="{{chosenFile?.name}}" /></mat-form-field>
            <input #fileUpload hidden type="file" (change)="onFileSelected($event.target.files)" />
            <button mat-raised-button [color]="'primary'" type="button" (click)="fileUpload.click()" class="fileButton"><i class="material-icons">attachment</i> Choose File</button>
            <p class="red error" *ngIf="fileTypeInvalid">Please choose a <span>{{AttachmentType.ExtensionList}}</span> file</p>
            <p class="red error" *ngIf="fileSizeOver">The file size maximum is <span>{{AttachmentType.SizeLimit | fileSize:0}}</span></p>
            <p class="red error" *ngIf="fileSizeUnder">The file size minimum is <span>{{AttachmentType.LowerSizeLimit | fileSize:0}}</span></p>
        </div>

        <p class="error" *ngIf="chosenFile == null">No file chosen</p>
        <p class="success" *ngIf="chosenFile != null">File Chosen!</p>
    </mat-card>


</div>